/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputUavMissionPlannedLaunches
 */
export interface InputUavMissionPlannedLaunches {
    /**
     * 
     * @type {number}
     * @memberof InputUavMissionPlannedLaunches
     */
    plannedLaunches?: number;
}

/**
 * Check if a given object implements the InputUavMissionPlannedLaunches interface.
 */
export function instanceOfInputUavMissionPlannedLaunches(value: object): boolean {
    return true;
}

export function InputUavMissionPlannedLaunchesFromJSON(json: any): InputUavMissionPlannedLaunches {
    return InputUavMissionPlannedLaunchesFromJSONTyped(json, false);
}

export function InputUavMissionPlannedLaunchesFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputUavMissionPlannedLaunches {
    if (json == null) {
        return json;
    }
    return {
        
        'plannedLaunches': json['plannedLaunches'] == null ? undefined : json['plannedLaunches'],
    };
}

export function InputUavMissionPlannedLaunchesToJSON(value?: InputUavMissionPlannedLaunches | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'plannedLaunches': value['plannedLaunches'],
    };
}

